import React, { useState } from "react";
import "./portfolio.css";
import { projectData } from "./data";
import Project from "./Project";

import {
  PortfolioContainer,
  PortfolioH1,
  SubTitle,
  PortfolioWrapper,
} from "./PortfolioElements";

const data = projectData;
const Portfolio = () => {
  const [visible, SetVisible] = useState(3);

  const LoadItems = () => {
    SetVisible((prevValue) => prevValue + 3);
  };

  return (
    <PortfolioContainer id="portfolio">
      <PortfolioH1>Portfolio</PortfolioH1>
      <SubTitle>Here are some of my works and solutions.</SubTitle>
      <PortfolioWrapper className="projects">
        {data.slice(0, visible).map((project) => {
          return <Project key={project.id} project={project} />;
        })}
        <button className="btn-" onClick={LoadItems}>
          Load more
        </button>
      </PortfolioWrapper>
    </PortfolioContainer>
  );
};

export default Portfolio;
